export const RESET_CUSTOMER_CREDIT_CARD_ISFETCHING =
  'RESET_CUSTOMER_CREDIT_CARD_ISFETCHING';
export const GET_CUSTOMER_CREDIT_CARD_REQUEST =
  'GET_CUSTOMER_CREDIT_CARD_REQUEST';
export const GET_CUSTOMER_CREDIT_CARD_SUCCESS =
  'GET_CUSTOMER_CREDIT_CARD_SUCCESS';
export const LIST_CUSTOMER_CREDIT_CARDS_REQUEST =
  'LIST_CUSTOMER_CREDIT_CARDS_REQUEST';
export const LIST_CUSTOMER_CREDIT_CARDS_SUCCESS =
  'LIST_CUSTOMER_CREDIT_CARDS_SUCCESS';
export const CUSTOMER_CREDIT_CARD_REQUESTING =
  'CUSTOMER_CREDIT_CARD_REQUESTING';
export const ADD_CUSTOMER_CREDIT_CARD_REQUEST =
  'ADD_CUSTOMER_CREDIT_CARD_REQUEST';
export const EDIT_CUSTOMER_CREDIT_CARD_REQUEST =
  'EDIT_CUSTOMER_CREDIT_CARD_REQUEST';
export const DELETE_CUSTOMER_CREDIT_CARD_REQUEST =
  'DELETE_CUSTOMER_CREDIT_CARD_REQUEST';
export const DELETE_CUSTOMER_CREDIT_CARD_SUCCESS =
  'DELETE_CUSTOMER_CREDIT_CARD_SUCCESS';
export const RESET_CUSTOMER_CREDIT_CARD_QUERY =
  'RESET_CUSTOMER_CREDIT_CARD_QUERY';
